"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.controlFlowTransformersModule = void 0;
const InversifyContainerFacade_1 = require("../../InversifyContainerFacade");
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../ServiceIdentifiers");
const ControlFlowReplacer_1 = require("../../../enums/node-transformers/control-flow-transformers/control-flow-replacers/ControlFlowReplacer");
const NodeTransformer_1 = require("../../../enums/node-transformers/NodeTransformer");
const BinaryExpressionControlFlowReplacer_1 = require("../../../node-transformers/control-flow-transformers/control-flow-replacers/BinaryExpressionControlFlowReplacer");
const BlockStatementControlFlowTransformer_1 = require("../../../node-transformers/control-flow-transformers/BlockStatementControlFlowTransformer");
const CallExpressionControlFlowReplacer_1 = require("../../../node-transformers/control-flow-transformers/control-flow-replacers/CallExpressionControlFlowReplacer");
const FunctionControlFlowTransformer_1 = require("../../../node-transformers/control-flow-transformers/FunctionControlFlowTransformer");
const LogicalExpressionControlFlowReplacer_1 = require("../../../node-transformers/control-flow-transformers/control-flow-replacers/LogicalExpressionControlFlowReplacer");
const StringArrayCallControlFlowReplacer_1 = require("../../../node-transformers/control-flow-transformers/control-flow-replacers/StringArrayCallControlFlowReplacer");
const StringArrayControlFlowTransformer_1 = require("../../../node-transformers/control-flow-transformers/StringArrayControlFlowTransformer");
const StringLiteralControlFlowReplacer_1 = require("../../../node-transformers/control-flow-transformers/control-flow-replacers/StringLiteralControlFlowReplacer");
exports.controlFlowTransformersModule = new inversify_1.ContainerModule((options) => {
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(BlockStatementControlFlowTransformer_1.BlockStatementControlFlowTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.BlockStatementControlFlowTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(FunctionControlFlowTransformer_1.FunctionControlFlowTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.FunctionControlFlowTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(StringArrayControlFlowTransformer_1.StringArrayControlFlowTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.StringArrayControlFlowTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.IControlFlowReplacer)
        .to(BinaryExpressionControlFlowReplacer_1.BinaryExpressionControlFlowReplacer)
        .whenNamed(ControlFlowReplacer_1.ControlFlowReplacer.BinaryExpressionControlFlowReplacer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.IControlFlowReplacer)
        .to(CallExpressionControlFlowReplacer_1.CallExpressionControlFlowReplacer)
        .whenNamed(ControlFlowReplacer_1.ControlFlowReplacer.CallExpressionControlFlowReplacer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.IControlFlowReplacer)
        .to(LogicalExpressionControlFlowReplacer_1.LogicalExpressionControlFlowReplacer)
        .whenNamed(ControlFlowReplacer_1.ControlFlowReplacer.LogicalExpressionControlFlowReplacer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.IControlFlowReplacer)
        .to(StringArrayCallControlFlowReplacer_1.StringArrayCallControlFlowReplacer)
        .whenNamed(ControlFlowReplacer_1.ControlFlowReplacer.StringArrayCallControlFlowReplacer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.IControlFlowReplacer)
        .to(StringLiteralControlFlowReplacer_1.StringLiteralControlFlowReplacer)
        .whenNamed(ControlFlowReplacer_1.ControlFlowReplacer.StringLiteralControlFlowReplacer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IControlFlowReplacer)
        .toFactory(InversifyContainerFacade_1.InversifyContainerFacade.getCacheFactory(ServiceIdentifiers_1.ServiceIdentifiers.IControlFlowReplacer));
});
